module.exports = __webpack_public_path__ + "img/smLogo.789e037e.png";